import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledChatRenderErrorFallback = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 20px;
`;

export const StyledChatRenderErrorText = styled.div`
  ${setFontVariant('body2', colorsPalettes.carbon[300])};
  text-align: center;
  max-width: 280px;
`;
